import axios from 'axios';

import { RestockingRule, RestockingRuleLinks, RestockingRulePayload } from './types';

const api = axios.create({
  baseURL: process.env.RESTOCKING_API_URI,
});

export const getRestockingRules = (
  venueId: string,
  params: {
    cursor?: string;
    limit: number;
  },
) =>
  api
    .get<{
      items: RestockingRule[];
      links: RestockingRuleLinks;
    }>(`/v1/venues/${venueId}/restocking-rules`, { params })
    .then(res => res.data);

export const createRestockingRule = (venueId: string, payload: RestockingRulePayload) =>
  api.post(`/v1/venues/${venueId}/restocking-rules`, payload);

export const editRestockingRule = (venueId: string, ruleId: string, payload: RestockingRulePayload) =>
  api.put(`/v1/venues/${venueId}/restocking-rules/${ruleId}`, payload);

export const deleteRestockingRule = (venueId: string, ruleId: string) =>
  api.delete(`/v1/venues/${venueId}/restocking-rules/${ruleId}`);

export default api;
